"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortByDesc = void 0;
const sort_by_desc_1 = require("../sort-by-desc");
exports.sortByDesc = (values, iteratees) => sort_by_desc_1.sortByDesc([...values], iteratees);
//# sourceMappingURL=sort-by-desc.js.map